<template>
  <div class="popup-list">
    <div class="header">
      <el-button type="primary" @click="onClickAdd">+ Qo'shish</el-button>
    </div>
    <el-table v-loading="loading" :data="popupList" border height="calc(100vh - 210px)">
      <el-table-column type="index" label="#"/>
      <el-table-column prop="content" label="Content" min-width="250"/>
      <el-table-column prop="is_active" label="Holati" align="center">
        <template v-slot="scope">
          <el-tag
              :type="scope.row.is_active?'success':'info'"
              effect="dark"
              round
          >
            {{ scope.row.is_active ? "Aktiv" : 'Aktiv emas' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="image" align="center" label="Rasm" min-width="70">
        <template v-slot="scope">
          <el-space>
            <div class="image-wrapper">
              <div class="mask" @click="clickMask(baseUrl+scope.row.image)">
                <img src="@/assets/images/icons/eye.svg" alt="EYE">
              </div>
              <el-avatar shape="square"
                         :src="scope.row.image?(baseUrl+scope.row.image):require('@/assets/images/default-img.png')"/>
            </div>
          </el-space>
        </template>
      </el-table-column>
      <el-table-column min-width="90" align="center">
        <template #default="scope">
          <el-button
              size="small"
              type="danger"
              @click="deletePopup(scope.row.id)"
          >O'chirish
          </el-button>
          <el-button
              size="small"
              type="primary"
              @click="
              $router.push({
                name: 'PopupFormEdit',
                params: { id: scope.row.id },
              })
            "
          >Tahrirlash
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <el-dialog v-model="imageVisible" style="text-align: center" align-center destroy-on-close>
    <el-image
        style="max-height: 90vh; width: auto; border-radius: 10px"
        fit="contain"
        :src="selectedImageSrc"
    />
  </el-dialog>
</template>

<script>
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";

export default {
  name: 'PopupList',
  data() {
    return {
      loading: false,
      popupList: [],
      totalCount: 0,
      selectedImageSrc: null,
      imageVisible: false,
      baseUrl: process.env.VUE_APP_BASE_API_URL + '/api/v2/info/file/'
    }
  },
  methods: {
    deletePopup(id) {
      ElMessageBox.confirm("Popupni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
          .then(() => {
            this.loading = true;
            this.$http
                .delete(`api/v1/popups/${id}`)
                .then(() => {
                  ElMessage({
                    type: "success",
                    message: "Muvaffaqqiyatli o'chirildi",
                  });
                  this.getPopupList();
                })
                .catch(() => {
                  ElNotification({
                    type: "error",
                    title: "Xatolik",
                    message: "Iltimos, qayta urinib ko'ring",
                  });
                })
                .finally(() => {
                  this.loading = false;
                });
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "O'chirish bekor qilindi",
            });
          });
    },
    clickMask(image) {
      this.selectedImageSrc = image
      this.imageVisible = true
    },
    onClickAdd() {
      this.$router.push({name: 'PopupFormAdd'})
    },
    getPopupList() {
      this.loading = true;
      this.$http
          .get("/api/v1/popups")
          .then(({data}) => {
            this.popupList = data;
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    }
  },
  mounted() {
    this.getPopupList()
  }
}
</script>

<style scoped>
.header {
  display: flex;
  margin-bottom: 10px;
  gap: 10px;
  justify-content: flex-end;
}

:deep(.el-dialog__body) {
  text-align: center !important;
}

.image-wrapper {
  position: relative;
  cursor: pointer;

  .mask {
    display: none;
    align-items: center;
    justify-content: center;
    position: absolute;
    inset: 0;
    border-radius: 5px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.46) 0%, rgba(0, 0, 0, 0.46) 100%);
  }

  &:hover {
    .mask {
      display: flex;
    }
  }
}
</style>
